// history.js — a stable view of completed workouts.
//
// state.sessions holds the finished history plus the live workout, so every
// logged set gives it a new identity. historyOf(sessions) returns the completed
// sessions as an array that keeps its identity for as long as no completed
// session was added, removed or edited: anything derived from history (PRs,
// "previous" values, analytics, the sync index) can be memoized on it and is
// not recomputed while you log sets. The check is a reference comparison
// (microseconds for thousands of workouts).

let last = { src: null, out: [] };
const views = new WeakMap(); // sessions array → history array (for several live arrays at once)

export function historyOf(sessions) {
  if (!Array.isArray(sessions)) return EMPTY;
  if (sessions === last.src) return last.out;
  const hit = views.get(sessions);
  if (hit) return hit;
  const prev = last.out;
  const out = [];
  let same = true;
  for (let i = 0; i < sessions.length; i++) {
    const s = sessions[i];
    if (!s || !s.completedAt) continue;
    if (same && prev[out.length] !== s) same = false;
    out.push(s);
  }
  const res = same && out.length === prev.length ? prev : out;
  last = { src: sessions, out: res };
  views.set(sessions, res);
  return res;
}
const EMPTY = Object.freeze([]);

/** state with sessions = historyOf(state.sessions), cached per history (for readiness(state)-style helpers). */
const withHist = new WeakMap();
export function historyState(state) {
  const h = historyOf(state && state.sessions);
  let cur = withHist.get(h);
  if (!cur || cur.src !== state) {
    // Keep the same object while the history and the other inputs are unchanged.
    if (cur && cur.view.bodyEntries === state.bodyEntries && cur.view.exercises === state.exercises && cur.view.prefs === state.prefs && cur.view.profile === state.profile && cur.view.programs === state.programs) return cur.view;
    cur = { src: state, view: { ...state, sessions: h } };
    withHist.set(h, cur);
  }
  return cur.view;
}
